import { createSvgIcon } from '@mui/material';

export const Share =
    createSvgIcon(
        <svg width="13" height="17" viewBox="0 0 13 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10.9882 7.2674H8.41324V1.2674C8.41324 -0.132605 7.65491 -0.415938 6.72991 0.634062L6.06324 1.3924L0.421575 7.80906C-0.353425 8.68406 -0.0284247 9.40073 1.13824 9.40073H3.71324V15.4007C3.71324 16.8007 4.47158 17.0841 5.39658 16.0341L6.06324 15.2757L11.7049 8.85906C12.4799 7.98406 12.1549 7.2674 10.9882 7.2674Z" fill="#A6914D" />
        </svg>

        ,
        "Share",
    )

export default Share;
